import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

import { environment } from '../../../environments/environment';
import { AuthTokenService } from '../../core/auth/auth-token.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  readonly productName = environment.application?.name ?? 'PDTF Cases';

  constructor(
    private oauth: OAuthService,
    private tokens: AuthTokenService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.tokens.isAuthenticated) {
      this.router.navigateByUrl('/cases');
    }
  }

  signIn(): void {
    this.oauth.initLoginFlow();
  }
}
